"use client";

import { useState } from "react";
import Image from "next/image";

const faqItems = [
   {
    title: "We Believe in Diversity & Equal Respect",
    content:
      "MSU values the strength of diversity and treats every employee with equal respect and dignity, creating a comfortable and inclusive workplace.",
  },
  {
    title: "Opportunities for Growth & Advancement",
    content:
      "As we continue to grow and break new boundaries, MSU offers numerous roles and responsibilities that encourage personal and professional development.",
  },
  {
    title: "Skill Development for a Changing World",
    content:
      "With rapidly evolving global trends, MSU prioritizes capacity building and continuous skill enhancement to ensure our staff remain competent and future-ready.",
  },
  {
    title: "State-of-the-Art Labs & Research Facilities",
    content:
      "Our advanced laboratories and facilities support cutting-edge research and innovative exploration, empowering faculty and students alike.",
  },
  {
    title: "Strategic Global Partnerships",
    content:
      "MSU’s international collaborations open doors to faculty exchange programs, global exposure, and collaborative research opportunities.",
  },
];

export default function WhyMSU() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className=" mt-[30px] md:mt-[60px] lg:mt-[80px] mx-auto bg-[#081E2D] py-[50px] md:py-[80px] lg:py-[100px]">
        <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
            {/* Heading */}
            <div className="mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                Why MSU?
                </h2>
                <p className="text-white/80 mt-2 max-w-2xl">
                Our vibrant campus provides an enriching society, in a diversified 
                community of endless creativity and vibrant festivities.
                </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
                {/* Left Accordion */}
                <div className="space-y-4">
                {faqItems.map((item, i) => (
                    <div
                    key={i}
                    className="bg-white shadow px-5 py-4 cursor-pointer transition-all"
                    >
                    <div
                        className="flex items-center justify-between"
                        onClick={() => toggle(i)}
                    >
                        <div className="flex items-center gap-3">
                        {/* Icon */}
                        <div className="h-10 w-10 bg-orange-400 rounded-full flex items-center justify-center text-white">
                            {i+1}
                        </div>

                        {/* Title */}
                        <p className="font-semibold text-gray-900">
                            {item.title}
                        </p>
                        </div>

                        {/* Plus / Minus */}
                        <span className="text-2xl font-normal text-gray-600">
                        {openIndex === i ? "−" : "+"}
                        </span>
                    </div>

                    {/* Content */}
                    <div
                        className={`overflow-hidden transition-all duration-300 ${
                        openIndex === i ? "max-h-40 mt-3" : "max-h-0"
                        }`}
                    >
                        <p className="text-gray-600 text-sm">{item.content}</p>
                    </div>
                    </div>
                ))}
                </div>

                {/* Right Image */}
                <div className="relative w-full h-[270px] md:h-[350px] lg:h-[400px]  overflow-hidden">
                <Image
                    src="https://cdn.msu.edu.in/why_Msu_7e70d0c60b.png" 
                    alt="Students in class"
                    fill
                    className="object-cover"
                />
                </div>
            </div>
      </div>
    </section>
  );
}
